export function formatLink(link?: string) {
    if (!link || link.startsWith("https://")) {
        return link;
    }

    if (link.startsWith("http://")) {
        const urlParts = link.split("http://");
        return "https://" + urlParts[1];
    }

    return "https://" + link;
}

export function isValidUrl(urlString: string): boolean {
    const urlRegex =
        /^(http(s):\/\/.)(?<!@)[-a-zA-Z0-9:%._+~#=]{1,256}\.[a-zA-Z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&=/]*)$/g;

    if (urlRegex.test(urlString)) {
        return true;
    }

    const formatedLink = formatLink(urlString);
    return urlRegex.test(formatedLink);
}

export function isCheck24Url(url: string) {
    const regex = /^(https:\/\/)?([a-z0-9\-]+\.)?(check24|24)\.de/;

    return regex.test(url);
}
